import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import DTOViajesServicios from '../../../DTOs/Operaciones/DTOViajesServicios'
const OpViajesServicios: DTOViajesServicios[] = []
const initialState = { OpViajesServicios }

export const OpViajesServiciosSlice = createSlice({
  name: 'OpViajesServicios',
  initialState: initialState,
  reducers: {
    resetOpViajesServicios : (state, action: PayloadAction<string>) => {
      state.OpViajesServicios =  []
    },  
    populateOpViajesServicios : (state, action: PayloadAction<DTOViajesServicios[]>) => {
        action.payload.forEach(element => {
            const index = state.OpViajesServicios.findIndex(object => object.id === element.id)
            if (index<0) state.OpViajesServicios.push(element)
        })
    },
    updateOpViajesServicios : (state, action: PayloadAction<DTOViajesServicios[]>) => {
      action.payload.forEach(row => {
      const i = state.OpViajesServicios.findIndex(_element => _element.id === row.id);
      if (i > -1) state.OpViajesServicios[i] = row;
      else state.OpViajesServicios.push(row);
    })
    },
    deleteOpViajesServicios : (state, action: PayloadAction<number>) => {
      const newArr = state.OpViajesServicios.filter(data => data.id != action.payload);
      state.OpViajesServicios=newArr
    },
  },
})

export const { resetOpViajesServicios, populateOpViajesServicios, updateOpViajesServicios, deleteOpViajesServicios } = OpViajesServiciosSlice.actions;
export default OpViajesServiciosSlice.reducer;